import React from "react";
import { LOGO_URL } from "@/lib/format";

export const Logo = ({ size = 40, withText = false, textClass = "" }) => (
  <div className="flex items-center gap-2.5">
    <img
      src={LOGO_URL}
      alt="MovingMyMama — Your Trusted Resource for Senior Transitions"
      className="object-contain shrink-0"
      style={{ height: size, width: "auto" }}
    />
    {withText && (
      <div className={`leading-tight ${textClass}`}>
        <div className="font-display font-bold text-[15px]">MovingMyMama</div>
        <div className="text-[11px] opacity-70">Command Center</div>
      </div>
    )}
  </div>
);
